import { useEffect, useState, useRef, useMemo } from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { Table, Empty, Modal, Button, message, Space, Tag } from 'antd';
import { getAll, drop, getLeaveTypesOdoo } from '../../../../apis/TipoIncapacidadApi';

const { confirm } = Modal;

const routes = [
  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Configuración</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Recursos Humanos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Tipos de Incapacidad</span>
      </>
    ),
  }
];

const ramasSeguro = {
  1: 'Riesgo Trabajo',
  2: 'Enfermedad General',
  3: 'Maternidad'
};

const tiposRiesgo = {
  0: 'Ninguno',
  1: 'Accidente Trabajo',
  2: 'Accidente Trayecto',
  3: 'Enfermedad Profesional'
};

const TipoIncapacidadPage = () => {
    const [items, setItems] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [objectSelected, setObjectSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    const [leaveTypesOdoo, setLeaveTypesOdoo] = useState([]);
    
    const columns = [
      {
        title: 'Tipo (Clave)',
        dataIndex: 'tipo',
        key: 'tipo',
      },
      {
        title: 'Descripción',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: 'Rama Seguro',
        dataIndex: 'rama_seguro',
        key: 'rama_seguro',
        render: (value) => ramasSeguro[value] || value
      },
      {
        title: 'Tipo Riesgo',
        dataIndex: 'tipo_riesgo',
        key: 'tipo_riesgo',
        render: (value) => tiposRiesgo[value] || value
      },
      {
        title: 'Tipo Ausencia',
        dataIndex: 'tipo_ausencia',
        key: 'tipo_ausencia',
        render: (value) => leaveTypeMap.get(String(value)) || value
      },
      {
        title: 'Estado',
        dataIndex: 'activo',
        key: 'activo',
        render: (value) => (
          <Tag color={value ? 'green' : 'red'}>
            {value ? 'Activo' : 'Inactivo'}
          </Tag>
        )
      },
      {
        title: 'Acciones',
        dataIndex: 'actions',
        key: 'actions',
        render: (_, record) => (
          <Space>
            <Button 
              type='primary' 
              size='small' 
              onClick={() => openDetails(record)}
            >
              Editar
            </Button>
            <Button 
              type='primary' 
              size='small' 
              danger 
              onClick={() => deleteConfirm(record)}
            >
              Eliminar
            </Button>
          </Space>
        )
      }
    ];

    const openDetails = async (object) => {
      setOpenEdit(true);
      setObjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas que deseas eliminar este tipo de incapacidad?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar esta información',
            onOk: () => deleteOk(item.id),
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id) => {
        const response = await drop(id);
        if(response.ok){
            message.success('¡El tipo de incapacidad ha sido eliminado!');
            await refreshData();
        }
        else{
            message.error(`¡Este tipo de incapacidad está siendo utilizado y no puede ser eliminado!`);
        }
    }

    const btnClick = () => {
      setOpenEdit(true);
      setObjectSelected(null);
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }
    const leaveTypeMap = useMemo(() => {
      return new Map(
        (leaveTypesOdoo || []).map(lt => [String(lt.id), lt.name ?? lt.display_name])
      );
    }, [leaveTypesOdoo]);

    const refreshData = async () => {
      setLoading(true);
      const response = await getAll();
      const responseOdoo = await getLeaveTypesOdoo();
      if(responseOdoo.ok){
        setLeaveTypesOdoo(responseOdoo.payload);
      }
      if(response.ok){
        setItems(response.payload);
      }
      setLoading(false);
    }

    const effectRan = useRef(false);
    useEffect(() => {
      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    return (
      <PageApp 
        routes={routes} 
        title={'Tipos de Incapacidad'} 
        extraCard={[
          <Button type="primary" onClick={btnClick}>
            Agregar Tipo de Incapacidad
          </Button>
        ]}
      >
        {
          loading ? (
            <p>Cargando...</p>
          ) : (
            items.length === 0 ? 
              <Empty description="No hay tipos de incapacidad registrados" /> : 
              <Table 
                dataSource={items} 
                columns={columns} 
                rowKey="id"
              />
          )
        }
        {
          openEdit && (
            <ModalEdit 
              title={objectSelected ? "Editar Tipo de Incapacidad" : "Crear Tipo de Incapacidad"} 
              id={objectSelected?.id} 
              open={openEdit} 
              finish={onHandlerFinish}
            />
          )
        }
      </PageApp>
    );
}   

export default TipoIncapacidadPage;